import type { NetworkPayload } from "../../../composites";
import type { GuidePlatform } from "./types";

const resourceUrl = "prompts";
const API = {
  getOnboardingPrompts: (platform: GuidePlatform): NetworkPayload => {
    return {
      url: `${resourceUrl}/onboarding/?platform=${platform}`,
      options: {
        method: "GET",
      },
    };
  },
  markPromptComplete: (uuid: string): NetworkPayload => {
    return {
      url: `${resourceUrl}/onboarding/completed`,
      options: {
        method: "POST",
        payload: {
          uuid,
        },
      },
    };
  },
};

export default API;
